/* global Drupal, jQuery, tns, AOS, YT */

import "./polyfill";
import MultiClamp from 'multi-clamp';
import 'bootstrap/js/dist/modal';

import {
  toTop
} from './library';


import MobileMenu from './components/MobileMenu';
import MainNavigation from './components/MainNavigation';
import Accordion from "./components/Accordion";
import SearchBar from "./components/SearchBar";
import HomeScrolling from './components/HomeScrolling';
import ProductFlagToggle from "./components/ProductFlagToggle";
import RobroyVideo from "./components/RobroyVideo";

if (typeof AOS !== 'undefined') {
  AOS.init();
}

// TODO: putting t
if (drupalSettings.video && drupalSettings.video.id) {
  var robroyVideo = new RobroyVideo(drupalSettings.video.id);
  window.onYouTubeIframeAPIReady = robroyVideo.preparePlayer;
}

(function (Drupal, $) {

  //Use this to interact with drupal behaviors module
  Drupal.behaviors.main = {
    attach: function (context, settings) {

      if (drupalSettings.user.uid) {
        new ProductFlagToggle(context);
      }

      new Accordion(context);

      if ((context !== document) || (context.tagName === 'SCRIPT')) {
        return;
      }

      // ------
      // To Top.
      const toTopTrigger = $('#to-top');
      if (!!toTopTrigger) {
        toTop(toTopTrigger[0], 300);
      }

      const items = document.querySelectorAll('article.node-article.node-view-mode-teaser:not(.article--type-chriss-corner) .article-title');
      Array.from(items).forEach((item) => {
        // clamp(item, 3);
        new MultiClamp(item, {
          ellipsis: '...',
          clamp: 3
        });
      })

      new HomeScrolling();

      // ----------
      // Init Components.

      new SearchBar();

      if (typeof tns !== "undefined" && context === document) {
        console.warn('init Slider', context);

        var slider = tns({
          container: '.field-client-quotes',
          // items: 3,
          // slideBy: 'page',
          fixedWidth: 400,
          // touch: true,
          swipeAngle: false,
          mouseDrag: true,
          nav: true,
          controls: false,
          navPosition: "bottom",
          arrowKeys: false,
          loop: false,
          navAsThumbnails: true,
          gutter: 32,
          edgePadding: 20,
          // controls: true,
          navContainer: '.slider-navigation',
          freezable: false,

          responsive: {
            680: {
              fixedWidth: 587,
              edgePadding: 40
            },
            // 860: {
            //
            // },
            1000: {
              edgePadding: 120,
            }
          }
        });
      }

      once('videoPopup', context.querySelectorAll('.paragraph--type--video-with-popup'))
      .forEach(function (wrapper) {

        const trigger = wrapper.querySelector('[data-video-trigger]');
        const modal = wrapper.querySelector('[data-video-modal]');
        const closeButtons = wrapper.querySelectorAll('[data-video-close]');
        const iframe = wrapper.querySelector('iframe');
        const video = wrapper.querySelector('video');

        if (!trigger || !modal) return;

        let lastFocusedElement = null;

        const getFocusableElements = () => {
          return modal.querySelectorAll(
            'a, button, textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])'
          );
        };

        trigger.addEventListener('click', function () {

          lastFocusedElement = document.activeElement;

          modal.removeAttribute('hidden');
          document.body.classList.add('modal-open');

          if (iframe && iframe.src.indexOf('autoplay') === -1) {
            iframe.src += (iframe.src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
          }

          if (video) {
            video.play();
          }

          const focusable = getFocusableElements();
          if (focusable.length) {
            focusable[0].focus();
          }

        });

        const closeModal = () => {

          modal.setAttribute('hidden', true);
          document.body.classList.remove('modal-open');

          if (iframe) {
            const src = iframe.src
              .replace('&autoplay=1', '')
              .replace('?autoplay=1', '');
            iframe.src = src;
          }

          if (video) {
            video.pause();
            video.currentTime = 0;
          }

          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }
        };

        closeButtons.forEach(function (btn) {
          btn.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
            closeModal();
          }
        });

        modal.addEventListener('keydown', function (e) {

          if (e.key !== 'Tab') return;

          const focusable = getFocusableElements();
          if (!focusable.length) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }

        });

    });

    }//end of inherited context and settings from drupal
  }//end of drupal behaviors
  /* global Javascript */

  //Create mobile menu.
  new MobileMenu();

  // //create main navigation menu.
  new MainNavigation();

}(Drupal, jQuery)); //end of drupal and jQuery closure
